export default __webpack_public_path__ + "static/media/address-icon.7c319066.svg";